import { AssignmentRule } from 'app/library/module-certificates/enums/assignment-rule.enum';
import { IModuleCertificateQuery } from '../interfaces/module-certificate.query.interface';

export class ModuleCertificate {
    static label_singular = 'moduleCertificate';
    static label_plural = 'moduleCertificates';

    static props_to_search = [];

    id: string;
    moduleId: string;
    certificateId: string;
    assignmentRule: AssignmentRule;

    constructor(moduleCertificate?: IModuleCertificateQuery) {
        if (moduleCertificate) {
            this.moduleId = moduleCertificate.module.id.toString();
            this.certificateId = moduleCertificate.template.id.toString();
            this.id = moduleCertificate.id ? moduleCertificate.id.toString() : null;
            this.assignmentRule = moduleCertificate.assignment_rule;
        } else {
            this.moduleId = null;
            this.certificateId = null;
            this.id = null;
            this.assignmentRule = null;
        }
    }
}
